import { Dialog, DialogContent } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export const HowToUse = ({ visible, setVisibility, videoURL }) => {
  return (
    <Dialog open={visible} onClose={() => setVisibility(false)} fullScreen>
      <DialogContent style={{ paddingTop: "15px" }}>
        <div className="text-gray-500" onClick={() => setVisibility(false)}>
          <span className="cursor-pointer">
            <CloseIcon></CloseIcon>
          </span>
        </div>
        <div className="flex justify-center" style={{ height: "95%" }}>
          <iframe
            src={videoURL}
            allow="autoplay"
            width={"80%"}
            height={"95%"}
          ></iframe>
        </div>
      </DialogContent>
    </Dialog>
  );
};
